import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Attaches 'X-Client-Code: CRM' to every request.
 * Also enables withCredentials for auth endpoints so the server
 * can set / read HTTP-only cookie refresh tokens.
 */
@Injectable()
export class ClientConfigInterceptor implements HttpInterceptor {
  private readonly CREDENTIAL_URLS = [
    '/api/CAS/login',
    '/api/CAS/tokenRefresh',
    '/api/CAS/signout',
    '/api/Authorization/RefreshToken',
    '/companies/user/change/password'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const configured = req.clone({
      withCredentials: this.shouldSendCredentials(req.url),
      setHeaders: { 'X-Client-Code': 'CRM' }
    });
    return next.handle(configured);
  }

  private shouldSendCredentials(url: string): boolean {
    const lower = url.toLowerCase();
    return this.CREDENTIAL_URLS.some(path => lower.includes(path.toLowerCase()));
  }
}
